var _defs, _path, _rect, _rect2, _polygon, _rect3, _rect4, _polygon2, _rect5, _rect6, _rect7, _rect8, _polygon3, _rect9, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSectionTool = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.5;isolation:isolate;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,8H13v8H3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 10,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 2,
    height: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 2 1 2 1 1 2 1 2 0 0 0 0 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 3,
    width: 1,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 2,
    height: 1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1 6 0 6 0 8 2 8 2 7 1 7 1 6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 1,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 2,
    height: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 2,
    height: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 2,
    height: 1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "14 0 14 1 15 1 15 2 16 2 16 0 14 0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 2,
    height: 1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "15 7 14 7 14 8 16 8 16 6 15 6 15 7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSectionTool);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/section-tool.09bea2f48b0112ff631bcc1c86298f86.svg";